import React, { useState, useEffect } from "react";
import { AlarmData} from "../Common/Types/types";
import { AlarmApi } from "./api";
import { defaultDate, max, min } from "../Common/Constants";
import AlarmStatisticsGrid from "./AlarmStatisticsGrid";
import { useSelector } from "react-redux";
import { getParamsSelector, updateParams } from "../Common/Slices/ParamSlice";
import { fetchAlarmDatas, fetchAlarmDatasWithScope, getAlarmsLoadingSelector, getAlarmsLoadingSelectorWithScope, getAlarmsSelector, getAlarmsWithScopeSelector } from "./Slice";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import { getDevicesSelector } from "../Devices/Slice";
import { useAppDispatch } from "../Core/store.hooks";
import FormatAlarms from "./FormatAlarms";
import { getOptionsSelector } from "../Common/Slices/optionSlice";
import Format from "../Common/Util_methods/formatParamOptions";
import { push } from 'react-router-redux';

import { determineScope, paramsById } from "../Common/Util_methods/scope";


interface AlarmScopeGridWidgetProps {
    id: string;
    header: string;
}

const AlarmScopeGridWidget = (props: AlarmScopeGridWidgetProps) => {
    const [AlarmDatas, updateAlarmDatas] = useState<AlarmData[]>();
    const [dataProcessed, setDataProcessed] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    const options = useSelector(getOptionsSelector)
    const deviceObjects = useSelector(getDevicesSelector)
    const params = useSelector(getParamsSelector)

    const alarms = useSelector(getAlarmsWithScopeSelector);
    const loadingState = useSelector(getAlarmsLoadingSelectorWithScope)

    useEffect(()=>{
        if (loadingState !== "pending"){
            updateAlarmDatas(FormatAlarms.durationInHours(alarms))
            setDataProcessed(true)
        }
    },[alarms])

    useEffect(()=>{
        if (loadingState==="pending"){
            setDataProcessed(false)
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
    },[loadingState])
    
    const handleRowClick = (id:string) =>{
        if (id != null){
            const newParams = paramsById(params,options,deviceObjects,id)
            if(newParams !== null){
                dispatch(updateParams(newParams))
            }
        }
    }

    if (!dataProcessed) return <Spinner text="data" />;
    if (AlarmDatas == null || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }
    if (AlarmDatas != null && AlarmDatas.length == 0) {
        return (
            <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
            />
        );
    }
    return <AlarmStatisticsGrid clickHandler={handleRowClick} alarmData={AlarmDatas}/>;
};
export default AlarmScopeGridWidget;
